import { Icon } from "@/ds";

import type { CargaSubbarProps } from "./types-carga-subbar";
import styles from "./carga-subbar.module.scss";

export function CargaSubbarView({ chips, onRemoverChip, children }: CargaSubbarProps) {
  return (
    <div className={styles.subbar} data-print-hide>
      <div className={styles.chips}>
        {chips.map((chip) => (
          <span key={chip.key} className={styles.chip} data-testid={chip.testId}>
            {chip.label}: {chip.values}
            <button
              type="button"
              aria-label={`Remover filtro de ${chip.label}`}
              onClick={() => onRemoverChip(chip.key)}
              className={styles.chipRemove}
            >
              <Icon name="times-circle" size={14} />
            </button>
          </span>
        ))}
      </div>

      {children}
    </div>
  );
}
